import type { SpareItem } from '@alwindows/shared/api/spareParts'

/**
 * Product = one or more SpareItem rows that share a RefMaterial. Items with no
 * RefMaterial are treated as their own product. The catalog UI renders one card
 * per product, with a colour swatch selector for products with >1 variant.
 */
export type Product = {
  refMaterial: string
  variants: SpareItem[]
}

export function groupByRefMaterial(items: SpareItem[]): Product[] {
  const groups = new Map<string, SpareItem[]>()
  for (const item of items) {
    const key = item.RefMaterial && item.RefMaterial.trim() !== '' ? item.RefMaterial : item.MaterialNo
    const existing = groups.get(key) ?? []
    existing.push(item)
    groups.set(key, existing)
  }
  return Array.from(groups.entries()).map(([refMaterial, variants]) => ({
    refMaterial,
    variants,
  }))
}

export function sortVariantsByColour(variants: SpareItem[], colourOrder: Map<string, number>): SpareItem[] {
  const score = (v: SpareItem) => colourOrder.get(v.Colour) ?? 999
  return [...variants].sort((a, b) => score(a) - score(b))
}
